import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* getUnmaskingConnection({ payload: { signal, id } }) {
  try {
    const { data } = yield call(fetch, { api: api.unmasking.connections.get, id, signal });

    yield put(actions.getUnmaskingConnectionDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getUnmaskingConnectionFailed,
      endpoint: api.unmasking.connections.get.url
    });
  }
}

export const getUnmaskingConnectionSaga = takeEvery(types.GET_UNMASKING_CONNECTION_REQUEST, getUnmaskingConnection);